const OVERLAY_EXCLUDED_URLS = ['/journeyActionLog', '/content/task-watch-progress'];

export default OVERLAY_EXCLUDED_URLS;
